var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFarmapolisColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_farmapolis_color",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff274c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#ff274c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.736,
    stopColor: "#953e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4e4e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3831",
    "data-name": "Grupo 3831",
    transform: "translate(108.793 31.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3830",
    "data-name": "Grupo 3830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2335",
    "data-name": "Trazado 2335",
    d: "M355.735,330.358h1.093v2.179a2.716,2.716,0,0,1,1.815-.655,2.4,2.4,0,0,1,2.539,2.507,2.546,2.546,0,0,1-4.372,1.8v.611h-1.075Zm1.093,4.97a2.457,2.457,0,0,0,1.613.691,1.544,1.544,0,0,0,1.631-1.594,1.569,1.569,0,0,0-1.666-1.6,2.3,2.3,0,0,0-1.578.655Z",
    transform: "translate(-355.735 -330.199)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2336",
    "data-name": "Trazado 2336",
    d: "M370.922,339.948a2.568,2.568,0,0,0,.67.106c.9,0,1.2-.381,1.2-.744a1.6,1.6,0,0,0-.194-.744l-1.895-3.925h1.2l1.6,3.473,1.6-3.473h1.2l-2.459,5.138a2.019,2.019,0,0,1-1.975,1.249,2.9,2.9,0,0,1-.952-.142Z",
    transform: "translate(-364.849 -332.799)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2337",
    "data-name": "Trazado 2337",
    d: "M394.5,334.4H395.6v.709h.026a1.814,1.814,0,0,1,1.658-.868,2.543,2.543,0,0,1,.388.018v1.187a2.348,2.348,0,0,0-.67-.089c-1.393.009-1.393.939-1.4,1.276v2.524H394.5Z",
    transform: "translate(-379.344 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2338",
    "data-name": "Trazado 2338",
    d: "M408.963,337.726a2.381,2.381,0,0,1-2.468,1.586,2.473,2.473,0,0,1-2.706-2.552,2.432,2.432,0,0,1,2.627-2.524c1.781.018,2.635,1.125,2.635,2.844H404.9a1.467,1.467,0,0,0,1.56,1.347,1.348,1.348,0,0,0,1.3-.7Zm-1.075-1.5a1.33,1.33,0,0,0-1.5-1.107,1.351,1.351,0,0,0-1.455,1.107Z",
    transform: "translate(-384.999 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2339",
    "data-name": "Trazado 2339",
    d: "M419.657,334.4h1.075v.611a2.464,2.464,0,0,1,1.833-.771,2.4,2.4,0,0,1,2.538,2.507,2.438,2.438,0,0,1-2.495,2.569,2.756,2.756,0,0,1-1.86-.655v2.126h-1.093Zm1.093,3.287a2.457,2.457,0,0,0,1.613.691,1.544,1.544,0,0,0,1.631-1.594,1.569,1.569,0,0,0-1.666-1.6,2.3,2.3,0,0,0-1.578.655Z",
    transform: "translate(-394.663 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2340",
    "data-name": "Trazado 2340",
    d: "M435.028,336.77a2.656,2.656,0,1,1,2.653,2.542A2.42,2.42,0,0,1,435.028,336.77Zm4.2-.018a1.543,1.543,0,1,0-3.085,0,1.544,1.544,0,1,0,3.085,0Z",
    transform: "translate(-404.024 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2341",
    "data-name": "Trazado 2341",
    d: "M450.773,336.552v-3.659h-1.049v-.939h1.049v-.549c0-1.47,1.5-1.452,1.86-1.452a5.864,5.864,0,0,1,1.181.141v.939a3.923,3.923,0,0,0-.96-.142c-.89-.035-.988.434-.988.735v.328h1.7v.939h-1.7v3.659Z",
    transform: "translate(-412.973 -329.953)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2342",
    "data-name": "Trazado 2342",
    d: "M466.307,338.382a2.147,2.147,0,0,0,.088.771h-1.119a2.227,2.227,0,0,1-.061-.478,3.985,3.985,0,0,1-2.072.638c-.626,0-1.833-.266-1.833-1.435,0-1.6,2.38-1.834,3.9-1.922v-.213c0-.363-.326-.62-1.225-.62-1,0-1.216.372-1.278.629h-1.137a2.157,2.157,0,0,1,2.406-1.515c2.283,0,2.327,1.116,2.327,1.771Zm-1.093-1.63a8.679,8.679,0,0,0-1.7.239c-.679.16-1,.39-1,.806s.255.664.793.664a3.673,3.673,0,0,0,1.913-.62Z",
    transform: "translate(-420.028 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2343",
    "data-name": "Trazado 2343",
    d: "M477.132,334.4h1.093v.709h.027a1.814,1.814,0,0,1,1.657-.868,2.54,2.54,0,0,1,.388.018v1.187a2.353,2.353,0,0,0-.67-.089c-1.393.009-1.393.939-1.4,1.276v2.524h-1.093Z",
    transform: "translate(-429.664 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2344",
    "data-name": "Trazado 2344",
    d: "M487.049,334.4h1.075v.541a2.132,2.132,0,0,1,1.6-.7,1.685,1.685,0,0,1,1.543.762,2.056,2.056,0,0,1,1.666-.762c1.058,0,1.816.443,1.816,1.55v3.366H493.66v-2.879c0-.8-.282-1.1-.952-1.1a1.958,1.958,0,0,0-1.261.6v3.375h-1.093v-2.879c0-.8-.282-1.1-.952-1.1a1.957,1.957,0,0,0-1.261.6v3.375h-1.093Z",
    transform: "translate(-435.704 -332.553)",
    fill: "#5d5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2345",
    "data-name": "Trazado 2345",
    d: "M513.888,338.382a2.159,2.159,0,0,0,.088.771h-1.119a2.207,2.207,0,0,1-.062-.478,3.983,3.983,0,0,1-2.072.638c-.626,0-1.833-.266-1.833-1.435,0-1.6,2.38-1.834,3.9-1.922v-.213c0-.363-.326-.62-1.225-.62-1.005,0-1.216.372-1.278.629h-1.137a2.157,2.157,0,0,1,2.406-1.515c2.283,0,2.327,1.116,2.327,1.771Zm-1.093-1.63a8.688,8.688,0,0,0-1.7.239c-.679.16-1,.39-1,.806s.256.664.793.664a3.671,3.671,0,0,0,1.913-.62Z",
    transform: "translate(-449.005 -332.553)",
    fill: "#5d5d5d"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2346",
    "data-name": "Trazado 2346",
    d: "M87.421,258.841a19.968,19.968,0,0,1,4.029.483v3.2a13.312,13.312,0,0,0-3.277-.483c-3.036-.121-3.367,1.48-3.367,2.508v1.118h5.8v3.2h-5.8V281.35H81.077V268.872H77.5v-3.2h3.577V263.8C81.077,258.78,86.188,258.841,87.421,258.841ZM110,278.721a7.344,7.344,0,0,0,.3,2.629h-3.818a7.575,7.575,0,0,1-.21-1.632,13.584,13.584,0,0,1-7.065,2.175c-2.134,0-6.253-.907-6.253-4.894,0-5.469,8.117-6.254,13.318-6.556v-.725c0-1.239-1.112-2.115-4.179-2.115-3.427,0-4.149,1.269-4.359,2.145H93.854c.9-4.411,5.2-5.166,8.207-5.166,7.786,0,7.936,3.807,7.936,6.043Zm-3.728-5.559a29.508,29.508,0,0,0-5.8.816c-2.315.543-3.4,1.329-3.427,2.749-.03,1.39.872,2.266,2.705,2.266a12.522,12.522,0,0,0,6.524-2.115Zm11.6-5.619h-.09v-2.417h-3.728V281.35h3.728v-8.611c.03-1.148.03-4.321,4.78-4.351a8.044,8.044,0,0,1,2.285.3v-4.049a8.628,8.628,0,0,0-1.323-.061A6.185,6.185,0,0,0,117.874,267.542Zm29.491-2.961a7.015,7.015,0,0,0-5.682,2.6,5.75,5.75,0,0,0-5.261-2.6,7.27,7.27,0,0,0-5.471,2.387v-1.843h-3.668V281.35h3.728V269.839a6.675,6.675,0,0,1,4.3-2.054c2.285,0,3.247,1.027,3.247,3.746v9.819h3.728V269.839a6.675,6.675,0,0,1,4.3-2.054c2.285,0,3.247,1.027,3.247,3.746v9.819h3.728V269.869C153.558,266.092,150.972,264.581,147.365,264.581Zm26.094,14.14a7.343,7.343,0,0,0,.3,2.629h-3.818a7.574,7.574,0,0,1-.21-1.632,13.584,13.584,0,0,1-7.065,2.175c-2.134,0-6.253-.907-6.253-4.894,0-5.469,8.117-6.254,13.318-6.556v-.725c0-1.239-1.112-2.115-4.179-2.115-3.427,0-4.149,1.269-4.359,2.145h-3.878c.9-4.411,5.2-5.166,8.207-5.166,7.786,0,7.936,3.807,7.936,6.043Zm-3.727-5.559a29.508,29.508,0,0,0-5.8.816c-2.315.543-3.4,1.329-3.427,2.749-.03,1.39.872,2.266,2.705,2.266a12.522,12.522,0,0,0,6.524-2.115Zm26.515-.03a8.316,8.316,0,0,1-8.508,8.762,9.394,9.394,0,0,1-6.343-2.236v7.251h-3.728V265.125h3.668v2.085a8.4,8.4,0,0,1,6.253-2.629C192.909,264.581,196.246,268.207,196.246,273.132Zm-3.788.121c0-3.656-2.826-5.469-5.682-5.469a7.862,7.862,0,0,0-5.381,2.236v6.315c1.443,1.118,2.946,2.357,5.5,2.357A5.268,5.268,0,0,0,192.458,273.253Zm23.809-.03c0,6.465-4.63,8.671-9.049,8.671s-9.049-2.206-9.049-8.671c0-4.35,2.615-8.641,9.049-8.641S216.267,268.872,216.267,273.222Zm-3.788-.06c0-3.807-2.435-5.378-5.261-5.378-2.856,0-5.261,1.571-5.261,5.378,0,3.444,1.924,5.529,5.261,5.529S212.479,276.606,212.479,273.162Zm7.064,8.188h3.728V259.385h-3.728Zm8.357,0h3.728V265.125H227.9Zm0-19.185h3.728v-3.323H227.9Zm15.152,9.155c-2.224-.3-3.788-.514-3.788-1.783,0-.907.9-1.964,3.607-1.964a5.894,5.894,0,0,1,5.261,2.538l3.1-1.722c-2.435-3.414-6.433-3.837-8.267-3.837-6.283,0-7.606,3.475-7.606,5.166,0,2.478,1.263,4.442,7.365,5.227,3.968.544,4.87.665,4.87,1.9,0,1.42-1.8,2.025-3.788,2.025-2.345,0-4.6-.665-5.892-2.78l-3.157,1.843c1.383,1.722,3.127,3.958,8.688,3.958,2.615,0,8.057-.544,8.057-5.318C251.5,272.558,247.472,271.893,243.052,271.319Z",
    transform: "translate(-77.5 -255.015)",
    fill: "url(#linear-gradient)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3832",
    "data-name": "Grupo 3832",
    transform: "translate(80.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2347",
    "data-name": "Trazado 2347",
    d: "M298.328,255.733,303,249.8a1.75,1.75,0,0,1,1.168-.68l7.577,0-4.725,5.935a1.484,1.484,0,0,1-1.184.68Z",
    transform: "translate(-292.321 -249.114)",
    fill: "#ff5773"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2348",
    "data-name": "Trazado 2348",
    d: "M296.376,255.728l-4.667-5.939a1.749,1.749,0,0,0-1.167-.681l-7.577,0,4.72,5.939a1.484,1.484,0,0,0,1.184.681Z",
    transform: "translate(-282.965 -249.105)",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2349",
    "data-name": "Trazado 2349",
    d: "M305.741,258.689l-7.41,0,3.7-4.7Z",
    transform: "translate(-292.323 -252.065)",
    fill: "#ff274c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFarmapolisColor);
export default __webpack_public_path__ + "static/media/ic_farmapolis_color.0430b280373bc45b00f5ca318be356e9.svg";
export { ForwardRef as ReactComponent };